import { Box, CircularProgress } from '@mui/material';

export default function RouteFallback() {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        width: '100%',
      }}
    >
      <CircularProgress size={48} />
    </Box>
  );
}
